module.exports = "https://web-assets.ifttt.com/packs/media/access_applet_card/paper-plane-e78833d4.svg";